import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, Link, Navigate, useNavigate } from 'react-router-dom';
import { safePostAuthDestination } from '../includes/auth/postAuthRedirect';
import { resendDeviceCode, signin, authenticate, isAuthenticated, getElakayLang, verificationCode } from "../includes/auth";
import { FaEye, FaEyeSlash, FaCheckCircle } from "react-icons/fa";
import { MdEmail, MdLock, MdSecurity, MdArrowForward, MdCheckCircle, MdRefresh, MdOutlineRadioButtonUnchecked  } from "react-icons/md";
import { BiWorld } from "react-icons/bi";
import Modal from 'react-bootstrap/Modal';
import logoelakayDiamant from '../includes/Layout/icon/logoelakayDiamant-256.png';
import CountdownTimer from './CountdownTimer';
import VerificationCodeInput from '../components/security/VerificationCodeInput';
import SuspendedAccountNotice from '../includes/pageInside/SuspendedAccountNotice';
import './user.css';
import AuthPageNav, { AuthDestinationNotice } from '../includes/auth/AuthPageNav';
import { elakayAutoText } from "../includes/pageInside/dataElakay";
import { displayAuthError } from "../includes/auth/authErrors";
import { RETURN_URL_QUERY_PARAM, getSafeReturnUrl } from "../utils/userAddingRoleToken";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["signin"]?.[key] || fallback;

function useQuery() {
    return new URLSearchParams(useLocation().search);
} 

function isNullOrEmpty(value) {
    if (value == null || value === false) return true;
    return false;
}

const Signin = (props) => {
    const { 
        infoSource,
        // Animation controls for Signin page
        enableHeaderAnimations = false,
        enableHeaderShapes = false,
        enableLogoAnimation = false,
        enableLogoPulse = false,
        enableLogoHover = false,
        enableParticles = false,

        particlesCount = 0,

        

        enableCardEntrance = false,
        enableCardGlow = false,
        enableFormGroupFade = false,
        enableInputFocus = false,
        enableButtonHover = false,

        enableTitleGlow = false,
       enableDecorationAnimations = false,
        enableButtonIcon = false,
        enablePasswordToggle = true,
        enableLinkHover = false,
        enableAlertSlide = false,
        enableLoadingDots = false,
        enableModalAnimations = false,
        enableFooterWaves = false,
        enableFooterLinkHover = false,
        enableVerificationIcon = false,
        enableCheckboxAnimation = false,

    // === HELP SECTION ===
        enableHelpSection = true,
        enableResendButton = true,
        enableResendIcon = false,

              // === COUNTDOWN TIMER ===
        enableCountdownTimer = true,
        enableCountdownAnimation = false,
        enableCountdownProgressBar = false,
        enableCountdownTimeText = true,
        countdownWarningThreshold = 300,  // 5 minutes
        countdownDangerThreshold = 60,    // 1 minute

          // === ALERTS ===
        enableSuccessAlert = true,
        enableSuccessIcon = true,

    } = props;
  __setElakayInfoSource(infoSource);

    let query = useQuery();
    let urlToken = query.get("token");
    let urlrandom = query.get("random");
    let trustDevice = query.get("trustDevice");
    // Preserves a pending /user_Shoosing/:token invitation through the
    // login round-trip (mission: "conserver le token pendant la connexion
    // ... après connexion, retourner vers /user_Shoosing/<token>").
    // getSafeReturnUrl() only ever accepts a same-origin relative path --
    // never an absolute/external URL (open-redirect guard).
    const safeReturnUrl = getSafeReturnUrl(query.get(RETURN_URL_QUERY_PARAM));

    const { obj } = getElakayLang();
    
    const [showPassword, setShowPassword] = useState(true);
    const [showConditions, setConditions] = useState(false);
    const [interfaceToken, setInterfaceToken] = useState('');
    const [saveInterface, setsaveInterface] = useState(false);


    const [ativatorData, setAtivatorData] = useState(null);
    const [isCodeExpired, setIsCodeExpired] = useState(false);
    const [isLoadingAtivator, setIsLoadingAtivator] = useState(false);

    const [values, setValues] = useState({
        numberDigi: "",
        email: "",
        password: "",
        error: "",
        errorCode: null,
        loading: false,
         Suc: false,
        redirectToReferrer: false,
        suspension: null
    });

    let navigate = useNavigate();
    const { numberDigi, email, password, loading, error, redirectToReferrer } = values;

    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const numberDigiRef = useRef(null);
    // Guards against double-submission when onComplete auto-fires as soon
    // as the 6th digit is entered -- reset on error/resend so a corrected
    // code can be auto-verified again.
    const lastSubmittedCodeRef = useRef("");

    const scrollToError = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
            ref.current.focus?.();
        }
    };

    const applyNewDeviceTimer = (challenge = {}) => {
        setIsLoadingAtivator(false);
        const randomExpires = challenge?.randomExpires;

        if (!randomExpires) {
            setAtivatorData(null);
            setIsCodeExpired(false);
            return;
        }

        const expiryTime = new Date(randomExpires).getTime();
        setAtivatorData({
            randomExpires,
            experyDate: challenge?.experyDate || randomExpires,
            createdAt: challenge?.createdAt || new Date().toISOString(),
            _id: challenge?._id || challenge?.challengeId
        });
        setIsCodeExpired(Number.isFinite(expiryTime) && Date.now() > expiryTime);
    };

    const handleChange = name => event => {
        setValues({ ...values, error: false, errorCode: null, [name]: event.target.value });
    };

    useEffect(() => {
        if (isNullOrEmpty(urlToken) || isNullOrEmpty(urlrandom)) return;

        const value = {
            interfaceToken: urlToken,
            numberDigi: urlrandom,
            saveInterface: trustDevice === "true"
        };

        setInterfaceToken(urlToken);
        setValues((current) => ({ ...current, error: false, errorCode: null, loading: true }));
        verificationCode(value)
            .then(data => {
                if (data.error) {
                    setValues((current) => ({ ...current, error: data.error, errorCode: data.code || null, loading: false, Suc: false }));
                    return navigate("/signin");
                }

                authenticate(data, () => {
                    setValues((current) => ({ ...current, loading: false, redirectToReferrer: true }));
                });
            });
    }, [urlToken, urlrandom, trustDevice, navigate]);

    const clickSubmitCode = (codeOverride) => {
        const codeToSubmit = codeOverride ?? numberDigi;

        if (isCodeExpired) {
            setValues({
                ...values,
                error: "", errorCode: "VERIFICATION_CODE_EXPIRED"
            });
            return;
        }

        if (!codeToSubmit || codeToSubmit.trim().length !== 6) {
            setValues({ ...values, error: "", errorCode: "INVALID_VERIFICATION_CODE_FORMAT" });
            scrollToError(numberDigiRef);
            return;
        }
        setValues({ ...values, error: false, errorCode: null, loading: true });
        verificationCode({ interfaceToken, numberDigi: codeToSubmit, saveInterface })
            .then(data => {
                if (data.error) {
                    lastSubmittedCodeRef.current = "";
                    setValues({ ...values, error: data.error, errorCode: data.code || null, loading: false, Suc: false });
                } else {
                    authenticate(data, () => {
                        setValues({
                            ...values,
                            redirectToReferrer: true
                        });
                    });
                }
            });
    };

    // Auto-submit as soon as the 6th digit is entered.
    const handleAutomaticVerification = useCallback((code) => {
        if (!/^\d{6}$/.test(code)) return;
        if (loading || lastSubmittedCodeRef.current === code) return;
        lastSubmittedCodeRef.current = code;
        clickSubmitCode(code);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, isCodeExpired, interfaceToken, saveInterface, values]);

    const clickSubmit = event => {
        // Only clear a pending activation token when this login isn't the
        // "log in to get back to my invitation" round-trip -- otherwise this
        // wiped token_userAdding before the redirect back to
        // /user_Shoosing/:token even had a chance to use it (mission 13.2:
        // clear the local token only once activation is complete, definitely
        // invalid, or explicitly requested -- not on an unrelated login).
        if (!safeReturnUrl) {
            localStorage.removeItem("token_userAdding");
        }
        event.preventDefault();

        if (loading) return;

        if (!email.trim()) {
            setValues({ ...values, error: "", errorCode: "EMAIL_REQUIRED" });
            scrollToError(emailRef);
            return;
        }

        if (!password) {
            setValues({ ...values, error: "", errorCode: "PASSWORD_REQUIRED" });
            scrollToError(passwordRef);
            return;
        }

        setValues({ ...values, error: false, errorCode: null, loading: true });
        signin({ email, password, language: obj })
            .then(data => {
                if (data.error) {
                    if (data.errorCode === 'ACCOUNT_SUSPENDED' || data.code === 'ACCOUNT_SUSPENDED') {
                        setValues({ ...values, error: false, errorCode: null, loading: false, suspension: data.suspension || {} });
                    } else {
                        // Keep the server's stable code (INVALID_PASSWORD,
                        // USER_NOT_FOUND, ACCOUNT_NOT_ACTIVATED, NETWORK_ERROR...)
                        // -- the banner translates it at render time.
                        setValues({ ...values, error: data.error, errorCode: data.code || null, loading: false });
                        if (data.field === "email" || data.code === "USER_NOT_FOUND") scrollToError(emailRef);
                        else if (data.field === "password" || data.code === "INVALID_PASSWORD") scrollToError(passwordRef);
                    }
                } else {
                    if (data.macInterface) {
                        setConditions(data.macInterface);
                        setInterfaceToken(data.token);
                        applyNewDeviceTimer(data);
                        setValues({ ...values, error: false, errorCode: null, loading: false, numberDigi: "", Suc: false });
                    } else {
                        authenticate(data, () => {
                            setValues({
                                ...values,
                                redirectToReferrer: true
                            });
                        });
                    }
                }
            });
    };

    const clickelakay = () => { 
        return window.location.href = "/";
    };

        // === HANDLER QUAND LE CODE EXPIRE ===
    const handleCodeExpired = () => {
        setIsCodeExpired(true);
        setValues({ 
            ...values, 
            error: "", errorCode: "VERIFICATION_CODE_EXPIRED"
        });
    };

    const suscceSendCode = () =>
        values?.Suc && (
            <div 
                className={`sign-alert sign-alert-success ${!enableSuccessAlert ? 'no-animation' : ''}`}
            >
                {enableSuccessIcon && <FaCheckCircle className="sign-alert-icon" />}
                <div className="sign-alert-content">
                    <p className="sign-alert-text">
                        {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text5 || 
                         "A new code has been sent to your email!"}
                    </p>
                    <p className="sign-alert-subtitle">
                        {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).checkEmail || 
                         "Please check your inbox."}
                    </p>
                </div>
            </div>
        );

    // Fonction utilitaire pour extraire la date de création depuis ObjectId
    const getCreatedAtFromObjectId = (objectId) => {
        if (!objectId) return null;
        try {
            const idString = objectId.toString ? objectId.toString() : objectId;
            const timestamp = parseInt(idString.substring(0, 8), 16) * 1000;
            return new Date(timestamp).toISOString();
        } catch (e) {
            return null;
        }
    };

    const resendCode = () => {
        const tokenForResend = interfaceToken || urlToken;
        if (!tokenForResend) {
            setValues({
                ...values,
                error: "", errorCode: "VERIFICATION_CODE_EXPIRED"
            });
            return;
        }

        setValues({ ...values, error: false, errorCode: null, loading: true });
        resendDeviceCode({ interfaceToken: tokenForResend })
            .then(data => {
                if (data.error) {
                    setValues({ ...values, error: data.error, errorCode: data.code || null, loading: false, Suc: false });
                } else {
                    setInterfaceToken(data.token || tokenForResend);
                    setIsCodeExpired(false);
                    applyNewDeviceTimer(data);
                    lastSubmittedCodeRef.current = "";
                    setValues({
                        ...values,
                        numberDigi: "",
                        Suc: true,
                        error: false, errorCode: null,
                        loading: false
                    });
                }
            });
    };

   const veryCodde = () => (
    <div className={`sign-verification-container ${!enableModalAnimations ? 'no-animation' : ''}`}>

        {/* Verification Icon */}
        <div className={`sign-verification-icon-wrapper ${!enableVerificationIcon ? 'no-animation' : ''}`}>
            <div className={`sign-verification-icon-circle ${!enableVerificationIcon ? 'no-pulse' : ''} ${isCodeExpired ? 'expired' : ''}`}>
                <MdSecurity className="sign-verification-icon" />
            </div>
        </div>

        <form>
            {/* Title */}
            <h6 className={`sign-verification-title ${!enableTitleGlow ? 'no-glow' : ''}`}>
                {isCodeExpired
                    ? (infoSource.laguangeElakay('signinPage', infoSource.languageAPI).titleExpired || "Code Expired")
                    : infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text1
                }
            </h6>

            {/* Subtitle */}
            {/* <p className="sign-verification-description">
                {isCodeExpired
                    ? (infoSource.laguangeElakay('signinPage', infoSource.languageAPI).subtitleExpired || "Your verification code has expired")
                    : infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text2
                }
            </p> */}

            {/* Countdown Timer */}
            {enableCountdownTimer && (
                <>
                    {isLoadingAtivator ? (
                        <div className="sign-countdown-wrapper">
                            <div className="sign-countdown-loading">
                                <div className="sign-dot"></div>
                                <div className="sign-dot"></div>
                                <div className="sign-dot"></div>
                            </div>
                            <span className="sign-loading-text">
                                {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).loadingTimer || "Loading timer..."}
                            </span>
                        </div>
                    ) : ativatorData && ativatorData.randomExpires ? (
                        <CountdownTimer
                            randomExpires={ativatorData.randomExpires}
                            experyDate={ativatorData.experyDate}
                            createdAt={ativatorData.createdAt || (ativatorData._id ? getCreatedAtFromObjectId(ativatorData._id) : null)}
                            onExpired={handleCodeExpired}
                            enableAnimation={enableCountdownAnimation}
                            showProgressBar={enableCountdownProgressBar}
                            showTimeText={enableCountdownTimeText}
                            warningThreshold={countdownWarningThreshold}
                            dangerThreshold={countdownDangerThreshold}
                            infoSource={infoSource}
                        />
                    ) : null}
                </>
            )}

            {showLoading()}
            {showError()}
            {suscceSendCode()}

            {/* Form Content — only when code is not expired */}
            {!isCodeExpired ? (
                <>
                    {/* Code Input -- shared 6-box OTP component (auto-advance, paste,
                        autofill, auto-submit on the 6th digit), same component used
                        in active.js's activation page. */}
                    <div className={`sign-form-group ${!enableFormGroupFade ? 'no-fade' : ''}`}>
                        <VerificationCodeInput
                            value={numberDigi}
                            onChange={(next) => setValues({ ...values, error: false, errorCode: null, numberDigi: next })}
                            onComplete={handleAutomaticVerification}
                            disabled={loading}
                            hasError={Boolean(error)}
                            ariaLabel={infoSource.laguangeElakay('placeholder', infoSource.languageAPI).enterCode || "6-digit verification code"}
                            autoFocus
                        />
                        <span className="sign-input-hint">{elakayAutoText("h_signin_hint_code", "Enter the 6-digit code we sent to your email")}</span>
                    </div>

                    {/* Save Device Checkbox */}
                    <div className={`sign-checkbox-wrapper ${!enableCheckboxAnimation ? 'no-animation' : ''}`}>
                        <input
                            className="sign-checkbox-input"
                            type="checkbox"
                            checked={saveInterface}
                            onChange={() => setsaveInterface(!saveInterface)}
                            value={saveInterface}
                            name="saveInterface"
                            id="saveInterface"
                        />
                        <label className="sign-checkbox-label" htmlFor="saveInterface">
                        {saveInterface ?  <MdCheckCircle className="sign-checkbox-icon" /> : <MdOutlineRadioButtonUnchecked  className="sign-checkbox-icon"/>}
                            {infoSource.laguangeElakay('label', infoSource.languageAPI).saveDevice}
                        </label>
                    </div>

                    <p className="sign-verification-note">
                        {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text3}
                    </p>

                    <input type="hidden" name="verication" placeholder="" />

                    {/* Submit Button */}
                    <div className="sign-button-group">
                        <button
                            type="button"
                            className={`sign-btn-primary ${enableButtonIcon ? 'sign-btn-animated' : ''} ${!enableButtonHover ? 'no-hover' : ''}`}
                            onClick={() => clickSubmitCode()}
                            disabled={loading}
                        >
                            <span>{infoSource.language(infoSource, 'Button', "submit")}</span>
                            {enableButtonIcon && <MdArrowForward className="sign-btn-icon" />}
                        </button>
                    </div>

                    {/* Resend Help */}
                    {enableHelpSection && (
                        <div className={`sign-activation-help ${!enableHelpSection ? 'no-animation' : ''}`}>
                            <p className="sign-help-text">
                                {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text4 || "Didn't receive the code?"}
                            </p>
                            {enableResendButton && (
                                <button
                                    type="button"
                                    className={`sign-link-resend ${!enableResendButton ? 'no-animation' : ''}`}
                                    onClick={() => resendCode()}
                                    disabled={loading}
                                >
                                    {enableResendIcon && <MdRefresh className={`sign-resend-icon ${loading ? 'spinning' : ''}`} />}
                                    {infoSource.laguangeElakay('Link', infoSource.languageAPI).newCode || "Resend Code"}
                                </button>
                            )}
                        </div>
                    )}
                </>
            ) : (
                /* Expired State Actions */
                <div className="sign-expired-actions">
                    <p className="sign-expired-message">
                        {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).expiredMessage ||
                            "Your verification code has expired. Click below to receive a new code."}
                    </p>

                    <div className="sign-button-group">
                        <button
                            type="button"
                            className={`sign-btn-primary sign-btn-full ${enableButtonIcon ? 'sign-btn-animated' : ''} ${!enableButtonHover ? 'no-hover' : ''}`}
                            onClick={() => resendCode()}
                            disabled={loading}
                        >
                            {enableButtonIcon && <MdRefresh className={`sign-btn-icon ${loading ? 'spinning' : ''}`} />}
                            <span>{infoSource.laguangeElakay('Button', infoSource.languageAPI).resendCode || "Get New Code"}</span>
                        </button>
                    </div>

                    <div className="sign-divider">
                        <span className="sign-divider-text">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t001}</span>
                    </div>

                    <Link
                        className={`sign-btn-secondary sign-btn-full ${!enableButtonHover ? 'no-hover' : ''}`}
                        to="/signup"
                    >
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount || "Create New Account"}
                    </Link>
                </div>
            )}
        </form>
    </div>
);

    const AddTermsAndConditions = () => (
        <Modal
            show={showConditions}
            onHide={() => setConditions(false)}
            dialogClassName={`sign-modal-dialog ${!enableModalAnimations ? 'no-animation' : ''}`}
            centered
        >
            <Modal.Header closeButton className="sign-modal-header">
                <Modal.Title className="sign-modal-title">
                    {infoSource.laguangeElakay('signinPage', infoSource.languageAPI).title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="sign-modal-body">
                {veryCodde()}
            </Modal.Body>
        </Modal>
    );

    const signUpForm = () => (
        <div className={`sign-page-wrapper ${!enableHeaderAnimations ? 'no-animations' : ''}`}>
            {/* Animated Header */}
            <header className={`sign-header ${!enableHeaderAnimations ? 'no-header-animation' : ''}`}>
                {enableHeaderShapes && (
                    <div className="sign-header-bg-shapes">
                        <div className="sign-shape sign-shape-1"></div>
                        <div className="sign-shape sign-shape-2"></div>
                        <div className="sign-shape sign-shape-3"></div>
                        <div className="sign-shape sign-shape-4"></div>
                    </div>
                )}
                
                <div className="sign-header-content">
                    <div 
                        className={`sign-logo ${!enableLogoHover ? 'no-hover' : ''}`}
                        onClick={() => clickelakay()}
                    >
                        <div className="sign-logo-icon-wrapper">
                            <img 
                                className={`sign-logo-image ${!enableLogoAnimation ? 'no-bounce' : ''}`}
                                src={logoelakayDiamant} 
                                width="40" 
                                alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t002}
                            />
                            {enableLogoPulse && <div className="sign-logo-pulse"></div>}
                        </div>
                        <span className="sign-logo-text">{__elakayText("t010", "elakay")}</span>
                    </div>
                    
                    <AuthPageNav />
                    {enableDecorationAnimations && (
                        <div className="sign-header-decorations">
                            <BiWorld className="sign-decoration-icon sign-decoration-1" />
                            <div className="sign-decoration-line"></div>
                        </div>
                    )}
                </div>
            </header>

            {/* Main Content */}
            <main className="sign-main-content">
                {enableParticles && (
                    <div className="sign-particles">
                        {[...Array(particlesCount)].map((_, i) => (
                            <div key={i} className="sign-particle" style={{
                                left: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 3}s`,
                                animationDuration: `${3 + Math.random() * 2}s`
                            }}></div>
                        ))}
                    </div>
                )}

                <div className="sign-form-container">
                    <div className={`sign-form-card ${!enableCardEntrance ? 'no-entrance' : ''}`}>
                        {enableCardGlow && <div className="sign-form-card-glow"></div>}

                        {values.suspension ? (
                            <SuspendedAccountNotice
                                suspension={values.suspension}
                                infoSource={infoSource}
                                onBack={() => setValues({ ...values, suspension: null, error: false, errorCode: null })}
                            />
                        ) : (
                        <form className="sign-form" onSubmit={clickSubmit}>
                            <div className="sign-form-header">
                                <h1 className={`sign-form-title ${!enableTitleGlow ? 'no-glow' : ''}`}>
                                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).signin}
                                </h1>
                                <p className="sign-form-subtitle">{__elakayText("t008", "Welcome back! Please enter your credentials")}</p>
                            </div>

                            <AuthDestinationNotice />
                            {showLoading()}
                            {showError()}

                            <div className={`sign-form-group ${!enableFormGroupFade ? 'no-fade' : ''}`}>
                                <label className="sign-input-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t003}</label>
                                <div className="sign-input-wrapper">
                                    <div className="sign-input-icon-wrapper">
                                        <MdEmail className={`sign-input-icon ${!enableInputFocus ? 'no-animation' : ''}`} />
                                    </div>
                                    <input
                                        ref={emailRef}
                                        onChange={handleChange("email")}
                                        type="email"
                                        value={email}
                                        name="email"
                                        id="inputEmail"
                                        className={`sign-form-input ${!enableInputFocus ? 'no-focus-animation' : ''}`}
                                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t004}
                                        required
                                    />
                                </div>
                                <span className="sign-input-hint">{elakayAutoText("h_signin_hint_email", "The email address you used to create your account")}</span>
                            </div>

                            <div className={`sign-form-group ${!enableFormGroupFade ? 'no-fade' : ''}`}>
                                <label className="sign-input-label">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t005}</label>
                                <div className="sign-input-wrapper">
                                    <div className="sign-input-icon-wrapper">
                                        <MdLock className={`sign-input-icon ${!enableInputFocus ? 'no-animation' : ''}`} />
                                    </div>
                                    <input
                                        ref={passwordRef}
                                        onChange={handleChange("password")}
                                        type={showPassword ? "password" : "text"}
                                        value={password}
                                        name="motsCache"
                                        id="inputPassword"
                                        className={`sign-form-input ${!enableInputFocus ? 'no-focus-animation' : ''}`}
                                        placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t006}
                                        required
                                    />
                                    {enablePasswordToggle && (
                                        <button
                                            type="button"
                                            className="sign-password-toggle"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                                        </button>
                                    )}
                                </div>
                                <span className="sign-input-hint">{elakayAutoText("h_signin_hint_password", "The password for your account")}</span>
                            </div>

                            <div className="sign-links-row">
                                {interfaceToken && (
                                    <Link 
                                        to="#" 
                                        className={`sign-link ${!enableLinkHover ? 'no-hover' : ''}`}
                                        onClick={() => setConditions(true)}
                                    >
                                        {infoSource.laguangeElakay('Link', infoSource.languageAPI).CheckDevise}
                                    </Link>
                                )}
                                <Link 
                                    to="/forget-password" 
                                    className={`sign-link sign-link-primary ${!enableLinkHover ? 'no-hover' : ''}`}
                                >
                                    {infoSource.laguangeElakay('Link', infoSource.languageAPI).forgetPassword}
                                </Link>
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                className={`sign-btn-primary sign-btn-full ${enableButtonIcon ? 'sign-btn-animated' : ''} ${!enableButtonHover ? 'no-hover' : ''}`}
                            >
                                <span>{infoSource.laguangeElakay('Button', infoSource.languageAPI).signin}</span>
                                {enableButtonIcon && <MdArrowForward className="sign-btn-icon" />}
                            </button>

                            <div className="sign-divider">
                                <span className="sign-divider-text">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).signin.t007}</span>
                            </div>

                            <Link 
                                className={`sign-btn-secondary sign-btn-full ${!enableButtonHover ? 'no-hover' : ''}`}
                                to="/signup"
                            >
                                {infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount}
                            </Link>
                        </form>
                        )}
                    </div>
                </div>
            </main>

            {/* Animated Footer */}
            <footer className={`sign-footer ${!enableFooterWaves ? 'no-waves' : ''}`}>
                {enableFooterWaves && (
                    <div className="sign-footer-waves">
                        <div className="sign-wave sign-wave-1"></div>
                        <div className="sign-wave sign-wave-2"></div>
                        <div className="sign-wave sign-wave-3"></div>
                    </div>
                )}
                
                <div className="sign-footer-content">
                    <p className="sign-footer-text">
                        © {new Date().getFullYear()}{__elakayText("t009", "elakay. All rights reserved.")}</p>
                    <div className="sign-footer-links">
                        <Link 
                            to="/privacy" 
                            className={`sign-footer-link ${!enableFooterLinkHover ? 'no-hover' : ''}`}
                        >{__elakayText("t011", "Privacy")}</Link>
                        <span className="sign-footer-separator">•</span>
                        <Link 
                            to="/terms" 
                            className={`sign-footer-link ${!enableFooterLinkHover ? 'no-hover' : ''}`}
                        >{__elakayText("t012", "Terms")}</Link>
                        <span className="sign-footer-separator">•</span>
                        <Link 
                            to="/help" 
                            className={`sign-footer-link ${!enableFooterLinkHover ? 'no-hover' : ''}`}
                        >{__elakayText("t013", "Help")}</Link>
                    </div>
                </div>
            </footer>
        </div>
    );

    // Re-computed on every render: a language switch re-translates an error
    // already displayed (errorCode + active language), no new request.
    const shownError = displayAuthError(values.errorCode, error);

    const showError = () => (
        <div
            className={`sign-alert sign-alert-danger ${!enableAlertSlide ? 'no-slide' : ''}`}
            style={{ display: shownError ? "" : "none" }}
            role="alert"
        >
            {/* Plain text: error messages are translated codes now, never
                server HTML (the old activation message embedded a link). */}
            <div>{shownError}</div>
        </div>
    );

    const showLoading = () =>
        loading && (
            <div className={`sign-alert sign-alert-loading ${!enableAlertSlide ? 'no-slide' : ''}`}>
                {enableLoadingDots && (
                    <div className="sign-loading-dots">
                        <div className="sign-dot"></div>
                        <div className="sign-dot"></div>
                        <div className="sign-dot"></div>
                    </div>
                )}
                <span className="sign-loading-text">
                    {infoSource.language(infoSource, "title", "loanding")}
                </span>
            </div>
        );

    // Already signed in: go where the user was heading. Not while
    // authenticate() is doing it itself after this sign in, and never back
    // to an auth page (no /signin -> /signin loop).
    const redirectUser1 = () => (isAuthenticated() && !redirectToReferrer
        ? <Navigate to={safePostAuthDestination(safeReturnUrl) || "/"} replace />
        : null);

    return (
        <div className="sign-app-wrapper"> 
            {redirectUser1()}
            {signUpForm()}
            {AddTermsAndConditions()}
        </div>
    );
};

export default Signin;
